import { create } from 'zustand';

type PresenceState = {
  onlineIds: Set<string>;
  setOnlineIds: (ids: Set<string>) => void;
  isOnline: (profileId: string) => boolean;
};

export const usePresenceStore = create<PresenceState>((set, get) => ({
  onlineIds: new Set(),
  setOnlineIds: (ids) => set({ onlineIds: ids }),
  isOnline: (profileId) => get().onlineIds.has(profileId),
}));
